export enum DisconnectSteps {
  INTRO = 'INTRO',
  RETENTION = 'RETENTION',
  REVIEW = 'REVIEW',
}

export enum TotalSteps {
  PREINSTALL = 2,
  DEFAULT = 3,
}
export enum ContactInfoSection {
  Address = 'Shipping Address',
  Email = 'Email Address',
}

export type Section = ContactInfoSection | null;

export type ModalProps = {
  isOpen: boolean;
  handleCancel?: () => void;
  handleContinue?: () => void;
};
